export default __webpack_public_path__ + "static/media/10.9b24c932.png";